Vendd.Scripts.load(function () {

    var $wrapper = $('.x-cookie-acceptance');

    if ($wrapper.length < 1 || LhApp.Context.IsConsentsEnabled)
        return;

    if ($.cookie('cookiesAcceptance'))
        return;

    $wrapper.addClass('visible');

    $wrapper.on('click', '.js-accept', function (e) {
        e.preventDefault();
        $.cookie('cookiesAcceptance', 'true', { expires: 30 });
        $wrapper.removeClass('visible');
    });

});